import React, { ReactNode } from 'react';
import { Typography } from '@scale/scaleui';
import { twMerge } from 'tailwind-merge';

type PanelEntryProps = {
  children: ReactNode;
  title: string;
  titleButton?: ReactNode;
  className?: string;
};

const PanelEntry: React.FC<PanelEntryProps> = ({ children, title, titleButton, className }) => {
  return (
    <div className={twMerge('flex flex-col gap-2 p-4 border-b border-neutral-200', className)}>
      <div className="flex items-center">
        <Typography.H5 className="text-base">{title}</Typography.H5>
        <div className="ml-auto">{titleButton}</div>
      </div>
      {children}
    </div>
  );
};

export default PanelEntry;
